'use client';

import ServiceContent from '@/components/services/ServiceContent';
import GeneralInfoMDXContent from '@/content/services/en/general-info.mdx';
import { styled } from '@mui/material/styles';
import { breakpoints, color, spacing } from '@/theme/tokens';
import { Box } from '@mui/material';

const StyledWrapper = styled(Box)`
    h3 {
        margin-top: ${spacing[24]};
        a {
            span {
                color: ${color.gray[80]} !important;
                font-size: 18px !important;
                font-weight: 700 !important;
            }
        }
        @media (max-width: ${breakpoints.md}) {
            margin-top: ${spacing[20]};
        }
        @media (max-width: ${breakpoints.sm}) {
            margin-top: ${spacing[16]};
        }
    }

    p:not(:first-of-type) {
        margin-bottom: ${spacing[0]};
    }

    ul {
        margin-bottom: ${spacing[8]};
    }
`;

export default function GeneralInfoContent() {
    return (
        <StyledWrapper>
            <ServiceContent>
                <GeneralInfoMDXContent />
            </ServiceContent>
        </StyledWrapper>
    );
}
